var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { DatasetApi } from './types/dataset-api.interface';
import { DatasetModel } from './types/dataset-model.interface';
let DatasetServiceImpl = class DatasetServiceImpl {
    constructor(_datasetApi, _datasetModel) {
        this._datasetApi = _datasetApi;
        this._datasetModel = _datasetModel;
    }
    fetchData(params) {
        return this._datasetApi.getDatasetApi(params).then((data) => {
            this._datasetModel.updateDataset(data.records);
            return data;
        });
    }
    getDataset() {
        return this._datasetModel.dataset;
    }
    getRowByIndex(index) {
        return this._datasetModel.getRowByIndex(index);
    }
    subscribe(callback) {
        return this._datasetModel.subscribe(callback);
    }
};
DatasetServiceImpl = __decorate([
    injectable(),
    __param(0, inject(DatasetApi)),
    __param(1, inject(DatasetModel)),
    __metadata("design:paramtypes", [typeof (_a = typeof DatasetApi !== "undefined" && DatasetApi) === "function" ? _a : Object, typeof (_b = typeof DatasetModel !== "undefined" && DatasetModel) === "function" ? _b : Object])
], DatasetServiceImpl);
export { DatasetServiceImpl };
